(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4414,1620],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 29655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ twilio; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var copy = {
  overline: "Twilio + Segment",
  heading: "Create intelligent customer engagement across every channel"
};
var cta = {
  text: "Sign up and start building",
  url: "https://www.twilio.com/try-twilio/?utm_source=segment&utm_medium=referral&utm_campaign=segment_better_together&utm_content=twilio_landing"
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroBase, {
      copyVariant: "wide",
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroSectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            tag: "h5",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyHeading, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            tag: "a",
            href: cta.url,
            size: "large",
            variant: "filled",
            color: "primary",
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: cta.text
          })]
        })
      })
    })
  });
};

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "e15yx4zd4"
} : 0)(Hero/* Wrapper */.im, "{gap:0;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:80px;}}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15yx4zd3"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledHeroSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e15yx4zd2"
} : 0)( true ? {
  name: "1wm219g",
  styles: "max-width:740px"
} : 0);

var StyledCopyHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e15yx4zd1"
} : 0)( true ? {
  name: "1dabe76",
  styles: "padding-bottom:24px"
} : 0);

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e15yx4zd0"
} : 0)( true ? {
  name: "1tus9sf",
  styles: "max-width:940px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/TwilioSegment/assets/TwilioSegment@2x.png
var TwilioSegment_2x = __webpack_require__(93453);
var TwilioSegment_2x_default = /*#__PURE__*/__webpack_require__.n(TwilioSegment_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/TwilioSegment/assets/TwilioSegment.webp
/* harmony default export */ var TwilioSegment = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/TwilioSegment/assets/TwilioSegment@2x.webp
var assets_TwilioSegment_2x = __webpack_require__(64183);
var assets_TwilioSegment_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TwilioSegment_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/TwilioSegment/TwilioSegmentImage.tsx








var TwilioSegmentImage = function TwilioSegmentImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(TwilioSegment, ", ").concat((assets_TwilioSegment_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (TwilioSegment_2x_default()),
      alt: "Twilio + Segment",
      width: "273",
      height: "80",
      loading: "lazy"
    })]
  });
};

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e18fcvqk0"
} : 0)("height:50px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{height:auto;}" + ( true ? "" : 0));

/* harmony default export */ var TwilioSegment_TwilioSegmentImage = (TwilioSegmentImage);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/TwilioSegment/TwilioSegment.tsx


function TwilioSegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var TwilioSegment_copy = {
  heading: "Twilio + Segment are better together with Twilio Engage",
  description: "Twilio Engage combines Twilio\u2019s scalable, reliable communication APIs with Segment\u2019s world-class customer data infrastructure, so you can design personalized omnichannel campaigns across all channels."
};
var TwilioSegment_link = {
  text: "Learn more",
  href: "/product/twilio-engage/"
};

var TwilioSegment_TwilioSegment = function TwilioSegment() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwilioSegment_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwilioSegment_TwilioSegmentImage, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TwilioSegment_StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
            variant: "h2",
            tag: "h2",
            children: TwilioSegment_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: TwilioSegment_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(TwilioSegment_link.href, pageConfig),
            children: TwilioSegment_link.text
          })]
        })]
      })
    })
  });
};

var TwilioSegment_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9t36y53"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9t36y52"
} : 0)("padding-bottom:16px;display:flex;justify-content:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

var TwilioSegment_StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e9t36y51"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e9t36y50"
} : 0)( true ? {
  name: "1erstqu",
  styles: "max-width:700px;margin:auto"
} : 0);

/* harmony default export */ var components_TwilioSegment_TwilioSegment = (TwilioSegment_TwilioSegment);
// EXTERNAL MODULE: ../../libs/templates/Testimonial/index.ts + 2 modules
var templates_Testimonial = __webpack_require__(5099);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/Testimonial/Testimonial.tsx





var Testimonial = function Testimonial() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(templates_Testimonial/* default */.Z, {
      company: "flowers-1800"
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1rr99pr0"
} : 0)("max-width:1060px;overflow:auto;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{margin-top:-80px;}" + ( true ? "" : 0));

/* harmony default export */ var Testimonial_Testimonial = (Testimonial);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/DelightYourCustomers/assets/DelightYourCustomers@2x.png
var DelightYourCustomers_2x = __webpack_require__(84041);
var DelightYourCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(DelightYourCustomers_2x);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/DelightYourCustomers/assets/DelightYourCustomers.webp
var DelightYourCustomers = __webpack_require__(3520);
var DelightYourCustomers_default = /*#__PURE__*/__webpack_require__.n(DelightYourCustomers);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/DelightYourCustomers/assets/DelightYourCustomers@2x.webp
var assets_DelightYourCustomers_2x = __webpack_require__(58452);
var assets_DelightYourCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DelightYourCustomers_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/DelightYourCustomers/DelightYourCustomersImage.tsx


function DelightYourCustomersImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var DelightYourCustomersImage = function DelightYourCustomersImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DelightYourCustomers_default()), ", ").concat((assets_DelightYourCustomers_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelightYourCustomersImage_StyledImage, {
      src: (DelightYourCustomers_2x_default()),
      alt: "Illustration: Delight your customers across all digital channels",
      width: "450",
      height: "471",
      loading: "lazy"
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e2v6wkc1"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

var DelightYourCustomersImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e2v6wkc0"
} : 0)( true ? {
  name: "oz49kj",
  styles: "max-width:450px"
} : 0);

/* harmony default export */ var DelightYourCustomers_DelightYourCustomersImage = (DelightYourCustomersImage);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/DelightYourCustomers/DelightYourCustomers.tsx


function DelightYourCustomers_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var DelightYourCustomers_copy = {
  heading: "Delight your customers across all digital channels",
  description: "Meet your customers where they are by engaging on any channel \u2013 video, voice, email and messaging \u2013 you name it."
};

var CreateOneCustomerConversation = function CreateOneCustomerConversation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelightYourCustomers_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DelightYourCustomers_StyledSectionBase, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: DelightYourCustomers_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: DelightYourCustomers_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelightYourCustomers_DelightYourCustomersImage, {})
      })]
    })
  });
};

var DelightYourCustomers_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed2bz7h1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var DelightYourCustomers_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ed2bz7h0"
} : 0)(Section/* Copy */.CK, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;align-self:center;}}" + ( true ? "" : 0));

/* harmony default export */ var DelightYourCustomers_DelightYourCustomers = (CreateOneCustomerConversation);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/CreateOneCustomerConversation/assets/CreateOneCustomerConversation@2x.png
var CreateOneCustomerConversation_2x = __webpack_require__(11920);
var CreateOneCustomerConversation_2x_default = /*#__PURE__*/__webpack_require__.n(CreateOneCustomerConversation_2x);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/CreateOneCustomerConversation/assets/CreateOneCustomerConversation.webp
var assets_CreateOneCustomerConversation = __webpack_require__(729);
var CreateOneCustomerConversation_default = /*#__PURE__*/__webpack_require__.n(assets_CreateOneCustomerConversation);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/CreateOneCustomerConversation/assets/CreateOneCustomerConversation@2x.webp
var assets_CreateOneCustomerConversation_2x = __webpack_require__(36460);
var assets_CreateOneCustomerConversation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CreateOneCustomerConversation_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/CreateOneCustomerConversation/CreateOneCustomerConversationImage.tsx


function CreateOneCustomerConversationImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CreateOneCustomerConversationImage = function CreateOneCustomerConversationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CreateOneCustomerConversationImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CreateOneCustomerConversation_default()), ", ").concat((assets_CreateOneCustomerConversation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateOneCustomerConversationImage_StyledImage, {
      src: (CreateOneCustomerConversation_2x_default()),
      alt: "Illustration: Create one customer conversation",
      width: "397",
      height: "447",
      loading: "lazy"
    })]
  });
};

var CreateOneCustomerConversationImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e182av9d1"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[4];
}, ");" + ( true ? "" : 0));

var CreateOneCustomerConversationImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e182av9d0"
} : 0)( true ? {
  name: "1h1nscx",
  styles: "max-width:397px"
} : 0);

/* harmony default export */ var CreateOneCustomerConversation_CreateOneCustomerConversationImage = (CreateOneCustomerConversationImage);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/CreateOneCustomerConversation/CreateOneCustomerConversation.tsx


function CreateOneCustomerConversation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var CreateOneCustomerConversation_copy = {
  heading: "Create one customer conversation",
  description: "Coordinate customer interactions across every touchpoint so your customer-facing teams always have the context to pick up where the conversation left off."
};

var CreateOneCustomerConversation_DelightYourCustomers = function DelightYourCustomers() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateOneCustomerConversation_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CreateOneCustomerConversation_StyledSectionBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: CreateOneCustomerConversation_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: CreateOneCustomerConversation_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateOneCustomerConversation_CreateOneCustomerConversationImage, {})
      })]
    })
  });
};

var CreateOneCustomerConversation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dekcll1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var CreateOneCustomerConversation_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1dekcll0"
} : 0)(Section/* Copy */.CK, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;align-self:center;}}" + ( true ? "" : 0));

/* harmony default export */ var CreateOneCustomerConversation_CreateOneCustomerConversation = (CreateOneCustomerConversation_DelightYourCustomers);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/MakeEveryInteractionMeaningful/assets/MakeEveryInteractionMeaningful@2x.png
var MakeEveryInteractionMeaningful_2x = __webpack_require__(49585);
var MakeEveryInteractionMeaningful_2x_default = /*#__PURE__*/__webpack_require__.n(MakeEveryInteractionMeaningful_2x);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/MakeEveryInteractionMeaningful/assets/MakeEveryInteractionMeaningful.webp
var MakeEveryInteractionMeaningful = __webpack_require__(61583);
var MakeEveryInteractionMeaningful_default = /*#__PURE__*/__webpack_require__.n(MakeEveryInteractionMeaningful);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/MakeEveryInteractionMeaningful/assets/MakeEveryInteractionMeaningful@2x.webp
var assets_MakeEveryInteractionMeaningful_2x = __webpack_require__(95198);
var assets_MakeEveryInteractionMeaningful_2x_default = /*#__PURE__*/__webpack_require__.n(assets_MakeEveryInteractionMeaningful_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/MakeEveryInteractionMeaningful/MakeEveryInteractionMeaningfulImage.tsx


function MakeEveryInteractionMeaningfulImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var MakeEveryInteractionMeaningfulImage = function MakeEveryInteractionMeaningfulImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MakeEveryInteractionMeaningfulImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((MakeEveryInteractionMeaningful_default()), ", ").concat((assets_MakeEveryInteractionMeaningful_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeEveryInteractionMeaningfulImage_StyledImage, {
      src: (MakeEveryInteractionMeaningful_2x_default()),
      alt: "Illustration: Make every interaction meaningful.",
      width: "350",
      height: "577",
      loading: "lazy"
    })]
  });
};

var MakeEveryInteractionMeaningfulImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1cj8pcr1"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[4];
}, ");" + ( true ? "" : 0));

var MakeEveryInteractionMeaningfulImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1cj8pcr0"
} : 0)( true ? {
  name: "lzq57f",
  styles: "max-width:350px"
} : 0);

/* harmony default export */ var MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningfulImage = (MakeEveryInteractionMeaningfulImage);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/MakeEveryInteractionMeaningful/MakeEveryInteractionMeaningful.tsx


function MakeEveryInteractionMeaningful_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var MakeEveryInteractionMeaningful_copy = {
  heading: "Make every interaction meaningful",
  description: "Identify your most important audiences and optimize for the best channel, time, frequency and message for every single customer."
};

var MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningful = function MakeEveryInteractionMeaningful() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeEveryInteractionMeaningful_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MakeEveryInteractionMeaningful_StyledSectionBase, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: MakeEveryInteractionMeaningful_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: MakeEveryInteractionMeaningful_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningfulImage, {})
      })]
    })
  });
};

var MakeEveryInteractionMeaningful_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1l7uafr1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var MakeEveryInteractionMeaningful_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1l7uafr0"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:120px;}", Section/* Copy */.CK, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;align-self:center;}}" + ( true ? "" : 0));

/* harmony default export */ var components_MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningful = (MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningful);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/LovedBy10MillionDevelopers/assets/LovedBy10MillionDevelopers@2x.png
var LovedBy10MillionDevelopers_2x = __webpack_require__(71540);
var LovedBy10MillionDevelopers_2x_default = /*#__PURE__*/__webpack_require__.n(LovedBy10MillionDevelopers_2x);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/LovedBy10MillionDevelopers/assets/LovedBy10MillionDevelopers.webp
var LovedBy10MillionDevelopers = __webpack_require__(60697);
var LovedBy10MillionDevelopers_default = /*#__PURE__*/__webpack_require__.n(LovedBy10MillionDevelopers);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/LovedBy10MillionDevelopers/assets/LovedBy10MillionDevelopers@2x.webp
var assets_LovedBy10MillionDevelopers_2x = __webpack_require__(35197);
var assets_LovedBy10MillionDevelopers_2x_default = /*#__PURE__*/__webpack_require__.n(assets_LovedBy10MillionDevelopers_2x);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/LovedBy10MillionDevelopers/LovedBy10MillionDevelopersImage.tsx








var LovedBy10MillionDevelopersImage = function LovedBy10MillionDevelopersImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LovedBy10MillionDevelopersImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((LovedBy10MillionDevelopers_default()), ", ").concat((assets_LovedBy10MillionDevelopers_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (LovedBy10MillionDevelopers_2x_default()),
      alt: "Illustration: Loved by 10 Million Developers",
      width: "640",
      height: "369",
      loading: "lazy"
    })]
  });
};

var LovedBy10MillionDevelopersImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ehdo2oi0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[4];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var LovedBy10MillionDevelopers_LovedBy10MillionDevelopersImage = (LovedBy10MillionDevelopersImage);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/LovedBy10MillionDevelopers/LovedBy10MillionDevelopers.tsx



var _templateObject;

function LovedBy10MillionDevelopers_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var LovedBy10MillionDevelopers_copy = {
  heading: "Loved by 10 Million Developers",
  description: "Twilio is optimized for builders, delivering a world-class experience and tools to let you build unique experiences, faster."
};
var LovedBy10MillionDevelopers_link = {
  url: "https://www.twilio.com/solutions/",
  text: "Explore our solutions"
};

var LovedBy10MillionDevelopers_LovedBy10MillionDevelopers = function LovedBy10MillionDevelopers() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LovedBy10MillionDevelopers_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LovedBy10MillionDevelopers_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LovedBy10MillionDevelopers_StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: [LovedBy10MillionDevelopers_copy.heading, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlinkingLine, {
              children: "_"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: LovedBy10MillionDevelopers_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: LovedBy10MillionDevelopers_link.url,
            children: LovedBy10MillionDevelopers_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LovedBy10MillionDevelopers_LovedBy10MillionDevelopersImage, {})
      })]
    })
  });
};

var LovedBy10MillionDevelopers_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezm9o323"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var LovedBy10MillionDevelopers_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ezm9o322"
} : 0)(Section/* Wrapper */.im, "{row-gap:64px;padding-bottom:120px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:120px;}}" + ( true ? "" : 0));

var cursor = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));

var BlinkingLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ezm9o321"
} : 0)("color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";animation:", cursor, " 1.5s infinite;" + ( true ? "" : 0));

var LovedBy10MillionDevelopers_StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "ezm9o320"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

/* harmony default export */ var components_LovedBy10MillionDevelopers_LovedBy10MillionDevelopers = (LovedBy10MillionDevelopers_LovedBy10MillionDevelopers);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/Signup/Signup.tsx


function Signup_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Signup_copy = {
  heading: "We can't wait to see what you build"
};
var Signup_button = {
  text: "Sign up and start building",
  url: "https://www.twilio.com/try-twilio/?utm_source=segment&utm_medium=referral&utm_campaign=segment_better_together&utm_content=twilio_landing"
};

var Signup = function Signup() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Signup_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Signup_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
        variant: "h2",
        children: Signup_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        color: "primary",
        variant: "filled",
        size: "large",
        href: Signup_button.url,
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: Signup_button.text
      })]
    })
  });
};

var Signup_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w1075h2"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1w1075h1"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);

var Signup_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1w1075h0"
} : 0)(Section/* Wrapper */.im, "{padding-top:96px;padding-bottom:120px;gap:26px;}" + ( true ? "" : 0));

/* harmony default export */ var Signup_Signup = (Signup);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/Resources/assets/State.png
var State = __webpack_require__(82446);
var State_default = /*#__PURE__*/__webpack_require__.n(State);
// EXTERNAL MODULE: ./src/views/TwilioSegment/components/Resources/assets/Twilio.png
var Twilio = __webpack_require__(3460);
var Twilio_default = /*#__PURE__*/__webpack_require__.n(Twilio);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/Resources/components/Cards.tsx


function Cards_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var cards = [{
  img: (State_default()),
  imgAlt: "Illustration: 2021 State of Customer Engagement report",
  badge: "Report",
  title: "2021 State of Customer Engagement report",
  content: "2020 transformed the way we communicate. Check out the State of Customer Engagement report to explore five trends defining digital engagement in 2021.",
  url: "https://www.twilio.com/state-of-customer-engagement/"
}, {
  img: (Twilio_default()),
  imgAlt: "Illustration: Leading brands are building with Twilio",
  badge: "Customer Story",
  title: "Leading brands are building with Twilio",
  content: "Explore what 200,000+ of your peers, from startups to global enterprises, have built with Twilio.",
  url: "https://customers.twilio.com/"
}];

var Cards = function Cards() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
      columns: 1,
      overrides: {
        md: 2
      },
      gap: "small",
      children: cards.map(function (card) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBase, {
          href: card.url,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Image */.Ee, {
            src: card.img,
            alt: card.imgAlt
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                  variant: "outlined",
                  children: card.badge
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                tag: "h3",
                children: card.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                variant: "pLarge",
                children: card.content
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
              alignment: "right",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
            })]
          })]
        }, card.title);
      })
    })
  });
};

var Cards_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xb89qm1"
} : 0)( true ? {
  name: "dezffx",
  styles: "max-width:960px"
} : 0);

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "e1xb89qm0"
} : 0)( true ? {
  name: "1puyml",
  styles: "max-width:464px;display:flex;flex-direction:column"
} : 0);

/* harmony default export */ var components_Cards = (Cards);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/Resources/Resources.tsx






var Resources_copy = {
  heading: "Resources",
  description: "Power your customer data strategy."
};

var Resources = function Resources() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Resources_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: Resources_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: Resources_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Cards, {})
      })]
    })
  });
};

var Resources_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ez6aw1q1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Resources_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ez6aw1q0"
} : 0)(Section/* Wrapper */.im, "{gap:64px;padding-top:40px;}" + ( true ? "" : 0));

/* harmony default export */ var Resources_Resources = (Resources);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var templates_LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/components/LogoCarousel/LogoCarousel.tsx





var logos = [data/* carouselLogos.CHIME */.j.CHIME, data/* carouselLogos.VACASA */.j.VACASA, data/* carouselLogos.INTUIT */.j.INTUIT, data/* carouselLogos.DOMINOS */.j.DOMINOS, data/* carouselLogos.IBM */.j.IBM, data/* carouselLogos.DELIVEROO */.j.DELIVEROO, data/* carouselLogos.BOX */.j.BOX, data/* carouselLogos.CRAFTJACK */.j.CRAFTJACK, data/* carouselLogos.DOORDASH */.j.DOORDASH];
var LogoCarousel_copy = {
  description: "The world\u2019s most innovative companies build personalized customer experiences with Twilio and Segment"
};

var LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(templates_LogoCarousel["default"], {
        logos: logos,
        heading: LogoCarousel_copy.description
      })
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1n9wj430"
} : 0)(Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding:64px 40px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding:64px 80px;}}" + ( true ? "" : 0));

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarousel);
;// CONCATENATED MODULE: ./src/views/TwilioSegment/TwilioSegment.tsx


















var TwilioSegmentView = function TwilioSegmentView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Unify Your Customer Data & Experience With Segment + Twilio | Twilio Segment",
      pageDescription: "Segment + Twilio together allow businesses to scale personalized, intelligent customer engagement with unified customer data.",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_TwilioSegment_TwilioSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelightYourCustomers_DelightYourCustomers, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateOneCustomerConversation_CreateOneCustomerConversation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MakeEveryInteractionMeaningful_MakeEveryInteractionMeaningful, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LovedBy10MillionDevelopers_LovedBy10MillionDevelopers, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources_Resources, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Signup_Signup, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1ryumv60"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:0;}" + ( true ? "" : 0));

/* harmony default export */ var views_TwilioSegment_TwilioSegment = (TwilioSegmentView);
;// CONCATENATED MODULE: ./src/pages/twilio/index.tsx



var twilio_TwilioSegment = function TwilioSegment() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(views_TwilioSegment_TwilioSegment, {});
};

/* harmony default export */ var twilio = (twilio_TwilioSegment);

/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonial_Testimonial; }
});

// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/data.tsx





var data = [{
  company: "box",
  logoName: "Box",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BoxMonoLogo */.Xb7, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CCustomerAI Predictions has equipped Box\u2019s marketing team with the ability to forecast customer behavior to a degree that was simply unavailable to us before. We\u2019ve been able to explore segmenting our audience based on predictive traits like who is most likely to join us at in-person events or who is more likely to purchase, and this allows us to meet those people where they are in their customer journey.\u201D",
  name: "Chris Koehler",
  position: "CMO at Box"
}, {
  company: "vacasa",
  logoName: "Vacasa",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VacasaMonoLogo */.Ciy, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio and Segment enable Vacasa to understand the entire customer journey to more effectively deliver personalized messages to guests and remove friction from their vacation experience.\u201D",
  name: "G Scott",
  position: "Director of Marketing Analytics",
  extendedRate: "3x",
  extendedText: "more guest bookings with personalized campaigns",
  extendedLink: "/customers/vacasa/"
}, {
  company: "fox",
  logoName: "Fox",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FoxMonoLogo */.xrs, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "When you use any of our mobile apps, you should be greeted like an old friend. When we deliver an ad to you, it should be relevant. When we suggest content to you, it should be in line with your tastes. This is all thanks to Segment.",
  name: "Daryl Bowden",
  position: "Executive Vice President, Technology Platforms at FOX Corporation",
  extendedRate: "376",
  extendedRateSymbol: "",
  extendedText: "more visitors to FOX Sports \u201CFor You\u201D app"
}, {
  company: "bonobos",
  logoName: "Bonobos",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BonobosMonoLogo */.Trx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAs our business grows, it has become increasingly important to understand how online spend influences offline behavior, which Facebook and Segment have made possible.\u201C",
  name: "Micky Onvural",
  position: "Co-President",
  extendedRate: "3x",
  extendedText: "increase in offline purchases versus control group",
  extendedLink: "/customers/bonobos/"
}, {
  company: "ibm",
  logoName: "IBM",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* IbmMonoLogo */.cEr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith real-time integrated data flows from Segment, we can truly understand what people are doing with our platform.\u201D",
  name: "Nic Sauriol",
  avatar: "",
  position: "Software Development Leader",
  extendedRate: "70",
  extendedRateSymbol: "%",
  extendedText: "increase in revenue following a three-month customer messaging pilot program",
  extendedLink: "/customers/ibm/"
}, {
  company: "rugs-com",
  logoName: "Rugs.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RugsComMonoLogo */.ONK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment\u2019s first-party audience targeting capabilities directly improved our return on ad spend. With better performing Google and Facebook campaigns...we were able to reinvest part of our optimized ad budgets into other high growth initiatives.\u201D",
  name: "Grayson Bagwell",
  position: "Director of Business Development and E-Commerce",
  extendedRate: "400",
  extendedRateSymbol: "%",
  extendedText: "YoY revenue growth",
  extendedLink: "/customers/rugs-dot-com/"
}, {
  company: "digital-ocean",
  logoName: "DigitalOcean",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DigitalOceanMonoLogo */.G7L, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment allows us to be more precise with how we dynamically suppress or target users in ad campaigns based on actual product usage.\u201D",
  name: "Sam Coren",
  position: "Senior Demand Generation Manager",
  extendedRate: "33",
  extendedRateSymbol: "%",
  extendedText: "improvement in cost per conversion",
  extendedLink: "/customers/digital-ocean/"
}, {
  company: "pager-duty",
  logoName: "PagerDuty",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* PagerDutyMonoLogo */.e90, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUsing Pendo and Segment to create this onboarding flow, rather than building it out as part of the core PagerDuty product, saves valuable time for engineering.\u201D",
  name: "Hailey Hickman",
  position: "Program Manager",
  extendedRate: "178",
  extendedRateSymbol: "%",
  extendedText: "increase in mobile app downloads",
  extendedLink: "/customers/pagerduty/"
}, {
  company: "drift",
  logoName: "Drift",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DriftMonoLogo */.BPv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe're using Twilio Engage as our new-age CRM. We identify which prospects are most likely to convert by aggregating individual user intent signals for each account...\u201D",
  name: "Guillaume Cabane",
  position: "Former VP of Growth",
  extendedRateSymbol: "%",
  extendedRate: "150",
  extendedText: "increase in positive conversations in 2 months",
  extendedLink: "/customers/drift/"
}, {
  company: "dominos",
  logoName: "Domino's",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Domino\u2019s turned to Twilio Segment to create a universal view of the customer, better visibility of ad campaign effectiveness, and create hyper personalized audiences with Twilio Engage to increase ROAS, revenue and incremental orders across all paid and owned e-commerce channels.",
  name: "",
  position: "Domino's",
  extendedRateSymbol: "%",
  extendedRate: "65",
  extendedText: "decrease in customer acquisition cost",
  extendedLink: "/customers/dominos/"
}, {
  company: "ab-in-bev",
  logoName: "ABInBev",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AbInBevMonoLogo */.gud, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201COur products are vital to our customers\u2019 businesses, and through BEES we\u2019ve empowered them to order the products their consumers love anytime, anywhere. Couple this with real time messaging about when their products will arrive, and what changes have taken place in the process, if any, has deepened our relationship with our customers immensely.\u201D",
  name: "Jason Lambert",
  position: "SVP Product at BEES",
  extendedRateSymbol: "",
  extendedRate: "$2",
  extendedText: "businesses buzzing through a next generation B2B platform with Twilio Segment",
  extendedLink: "/customers/ab-inbev/"
}, {
  company: "crypto-com",
  logoName: "Crypto.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CryptoComMonoLogo */.K9k, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe knew from day one that Twilio\u2019s solutions were the most qualified because our developers had first-hand experience, knowledge, and success working with them in the past.\u201D",
  name: "Matthew Chan",
  position: "Chief Technology Officer",
  extendedRateSymbol: "%",
  extendedRate: "900",
  extendedText: "forecasted increase in user-base by 2023",
  extendedLink: "/customers/crypto/"
}, {
  company: "earnest",
  logoName: "Earnest",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment provided Earnest with a single user identity and consistent, granular customer data that the team needed to create the advanced, customized metrics to scale the affiliate program.\u201D",
  name: "Goutham Valeti",
  position: "Head of Analytics",
  extendedRate: "10x",
  extendedText: "loan volume growth and saved borrowers well over $100M",
  extendedLink: "/customers/earnest/"
}, {
  company: "clear-score",
  logoName: "ClearScore",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe cost of a Segment investment completely beat our in-house options out of the water. It was a no-brainer in terms of cost.\u201D",
  name: "Klaus Thorup",
  avatar: "",
  position: "Chief Technology Officer",
  extendedRate: "3x",
  extendedText: "cost savings with Twilio Segment instead of building in-house",
  extendedLink: "/customers/clearscore/"
}, {
  company: "toggle",
  logoName: "Toggle",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ToggleMonoLogo */.nSO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWhat we have in Segment is a platform for serendipity. We\u2019re able to react to many scenarios, innovate quickly, scale resources, and bolster a culture of digital transformation.\u201D",
  name: "Todd Wright",
  position: "Sr. Technologist",
  extendedRateSymbol: "%",
  extendedRate: "64",
  extendedText: "decrease in cost per acquisition",
  extendedLink: "/customers/toggle/"
}, {
  company: "stylepit",
  logoName: "Stylepit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* StylepitMonoLogo */.$K_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment proved to us that our first-party data was more valuable than any third-party data\u2014even third-party tracking cookies\u2014could provide.\"",
  name: "Martin Brummerstedt",
  position: "Data Scientist & Digital Project Manager",
  extendedRate: "1.7x",
  extendedText: "increase in ROAS",
  extendedLink: "/customers/stylepit/"
}, {
  company: "tradesy",
  logoName: "Tradesy",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradesyMonoLogo */.qKx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe played around and built a couple of prototypes for our own data pipeline, but we quickly realized that it would take three engineers six months to stabilize a platform, and even then it would not be as feature-rich as Segment.\u201D",
  name: "Geoff Apps",
  position: "CTO at Tradesy",
  extendedRate: "6",
  extendedText: "months saved in engineering time",
  extendedLink: "/customers/tradesy/"
}, {
  company: "frame-io",
  logoName: "FrameIo",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FrameIoMonoLogo */.QzL, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CFrame.io needed a definitive 'single source of truth' where they could unify diverse data sources that would provide the full picture of their customers and Twilio Segment provided that.\u201D",
  name: "Kyle Gesuelli",
  position: "Head of Growth",
  extendedRateSymbol: "%",
  extendedRate: 80,
  extendedText: "reduction in the handle time on support tickets",
  extendedLink: "/customers/frameio/"
}, {
  company: "retool",
  logoName: "Retool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RetoolMonoLogo */.U8Y, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAfter we looked at the costs of building the basic infrastructure and the support required, Twilio Segment became a no-brainer and we upgraded from their Startup Program.\u201D",
  name: "Jane Kelly",
  position: "Head of Growth",
  extendedRateSymbol: "",
  extendedRate: "1000+",
  extendedText: "Retool saved over 1,000 engineering hours by using Twilio Segment",
  extendedLink: "/customers/retool/"
}, {
  company: "meredith",
  logoName: "Meredith",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MeredithMonoLogo */.eqZ, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has enabled us to streamline the data capture process while maintaining flexibility to customize per brand as needed.\u201C",
  name: "Grace Preyapongpisan",
  position: "Vice President, Business Intelligence",
  extendedRate: 36,
  extendedText: "brands centralized on the same data analytics infrastructure",
  extendedLink: "/customers/meredith/"
}, {
  company: "candu",
  logoName: "Candu",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CanduMonoLogo */.IBI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe developer experience with Segment was super easy. Docs were robust enough for us to follow and build an integration within a day.\u201C",
  name: "Michele Riccardo Esposito",
  position: "Chief Technology Officer"
}, {
  company: "looker",
  logoName: "Looker",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LookerMonoLogo */.lpP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CHaving a consistent pipeline of clean and standardized first-party data from Segment is an extremely valuable and core data set for our customers\u2019 success.\u201C",
  name: "Keenan Rice",
  position: "VP Strategic Alliances"
}, {
  company: "trustpilot",
  logoName: "Trustpilot",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TrustpilotMonoLogo */.OPh, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment\u2019s Privacy Portal gives us the confidence to align our event data streams with our company\u2019s data privacy and governance standards. With real-time visibility across our event streams, we are able to proactively respect our customers\u2019 privacy.\u201C",
  name: "Rudy Martin",
  position: "Chief Information Security Office"
}, {
  company: "adviso",
  logoName: "Adviso",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdvisoMonoLogo */.HXI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWorking with Segment allows us to better serve our clients by delivering deeper insights, more quickly. Segment reduces time spent building data pipelines and allows us to provide access to reliable, clean, and actionable data to our customers.\u201C",
  name: "Louis-Philippe Mathieu",
  position: "Data Scientist"
}, {
  company: "prolific-interactive",
  logoName: "ProlificInteractive",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ProlificInteractiveMonoLogo */.BDm, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment understands the value of having their end-users be experts on the platform, and that remains a top priority for them. Instead of simply doing it for you, they take the time to guide you to a deeper level of understanding of the nuances of their platform.\u201C",
  name: "David Reyneke",
  position: "Sr. Growth Manager"
}, {
  company: "y-combinator",
  logoName: "YCombinator",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* YCombinatorMonoLogo */.ah_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment helps businesses set up analytics the way it was meant to be \u2014 quantifying product-market fit, understanding customers, and trying new tools \u2014 all without redundant or time-consuming work.\u201C",
  name: "Gustaf Alstr\xF6mer",
  position: "Partner at Y Combinator"
}, {
  company: "flowers-1800",
  logoName: "Flowers1800",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* Flowers1800MonoLogo */.QZv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Twilio Engage, we are able to collect, unify and connect customer data in real time and build meaningful relationships at every touchpoint of the customer journey. We\u2019re accelerating our digital business and data infrastructure by nearly a decade, and by doing so, delighting our customers.\u201C",
  name: "Amit Shah",
  position: "President"
}, {
  company: "shutterstock",
  logoName: "Shutterstock",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ShutterstockMonoLogo */.IcO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Shutterstock partnered with Segment to unlock the personalization power for their email campaigns. Segment\u2019s expertise accelerated the digital media marketplace\u2019s customer experience with contextually relevant messaging and a 30% lift in click rates."
}, {
  company: "typeform",
  logoName: "Typeform",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TypeformMonoLogo */.wJ3, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUntil we started standardizing our data, people didn\u2019t realize how messy it had become. With Protocols, we can be confident that data quality issues don\u2019t happen anymore.\u201D",
  name: "Colin Furlong",
  position: "Data Operations & Tracking",
  extendedRateSymbol: "%",
  extendedRate: 75,
  extendedText: "Reduction in duplicate or extraneous tracked events",
  extendedLink: "/customers/typeform/"
}, {
  company: "creative-market",
  logoName: "CreativeMarket",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CreativeMarketMonoLogo */.w1t, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CProtocols provides the context my teams need to effectively use our customer data in campaigns and analyses.\u201D",
  name: "Akshay Singh",
  position: "Former extended & Product Analytst",
  extendedRateSymbol: "%",
  extendedRate: 93,
  extendedText: "Reduction in time to detect data issues",
  extendedLink: "/customers/creative-market/"
}, {
  company: "allergan",
  logoName: "Allergan",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe lean heavily on Segment today to identify our consumers and their profile traits, what makes them them, and what kind of journey they are on.\u201D",
  name: "Christine Li",
  position: "Director of Marketing Technology",
  extendedRate: "400M+",
  extendedText: "In sales driven in 2021 YTD by direct-to-consumer",
  extendedLink: "/customers/allergan/"
}, {
  company: "amboss",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AmbossMonoLogo */.D9K, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "Amboss",
  text: "\u201C[...]Twilio Segment has been game-changing, helping us to centralize our customer data far more quickly, efficiently and cost effectively than we could have imagined.\u201D",
  name: "Elmar Weber",
  position: "Chief Technical Officer",
  extendedText: "Reduced time to insights from days to minutes",
  extendedLink: "/customers/amboss/"
}, {
  company: "chopra",
  logoName: "Chopra",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ChopraMonoLogo */.aIE, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is significantly cheaper than having a full data team[...]and allowed us to see what our customers are actually doing.\u201D",
  name: "Josh Wexler",
  position: "Chief Product Officer",
  extendedText: "Maximized resources resulting in the building of data-driven products",
  extendedLink: "/customers/chopra/"
}, {
  company: "ritual",
  logoName: "Ritual",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe use Segment as our CDP and the biggest thing it\u2019s given us is flexibility[...]to define what the ideal experience is for our customers.\u201D",
  name: "Laura Brodie",
  position: "Director of Customer Lifecycle and Growth",
  extendedText: "More agile audience development and increased LTV over time",
  extendedLink: "/customers/ritual/"
}, {
  company: "theVintageBar",
  logoName: "TheVintageBar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheVintageBarMonoLogo */.u$x, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has empowered our company to make decisions smarter and faster to give our customers the best experience possible. With constant experimentation, sophisticated customer data models, and journey mapping, we can deliver personalization at scale and across all channels.\u201D",
  name: "Nikolaj Toxv\xE6rd",
  position: "Chief Marketing Officer",
  extendedRate: "6x",
  extendedText: "inventory growth in 6 months with optimized experiences",
  extendedLink: "/customers/the-vintage-bar/"
}, {
  company: "good-eggs",
  logoName: "GoodEggs",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* GoodeggsMonoLogo */.nCX, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment has proven not only to be simple, fast, and reliable \u2014 but also an accelerant. Engineering can now focus on features and use cases, rather than infrastructure to get our events from the edge to downstream systems.\"",
  name: "Bob Zoller",
  position: "Founding Engineer",
  extendedRate: "0 Hours",
  extendedText: "engineering time spend managing data pipelines",
  extendedLink: "/customers/goodeggs/"
}, {
  company: "halp",
  logoName: "Halp",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* HalpMonoLogo */.JRr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Using Segment, you save a combination of time and money.\"",
  name: "Fletcher Richman",
  position: "CEO and Co-Founder",
  extendedRate: "4x",
  extendedText: "improvement in the number of activated sign-ups",
  extendedLink: "/customers/halp/"
}, {
  company: "craft-jack",
  logoName: "CraftJack",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CraftJackMonoLogo */.Vsb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"With Twilio Engage, we are able to do the work of three or four different tools, all in one centralized platform. We are able to bring transactional conversation and personalized marketing messages all into Twilio Engage for greater efficiency.\"",
  name: "Jordan Dietch",
  position: "VP of Product Management, CraftJack",
  extendedText: "31% increase in new user signups YoY and 80% increase in engineering implementation efficiency",
  extendedLink: "/customers/craftjack/"
}, {
  company: "mongodb",
  logoName: "mongodb",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSince implementing Segment we have seen a significant increase in revenue which we attribute to the improved targeting and personalization of our communications.\u201D"
}, {
  company: "sanofi",
  logoName: "sanofi",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to easily utilize and activate data.\u201D"
}, {
  company: "the-motley-fool",
  logoName: "the-motley-fool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheMotleyFoolMonoLogo */.DeK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is much more of a self-service platform. Whereas before we were limited in how we could message or target prospects and members, we can now build and activate audiences almost immediately.\u201D"
}, {
  company: "univision",
  logoName: "univision",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* UnivisionMonoLogo */.KML, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CRegardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn\u2019t\n    have done this any other way.\u201C"
}, {
  company: "crossfit",
  logoName: "crossfit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CrossFitMonoLogo */.DvB, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CNow, our data and teams are cohesive and connected, we can make data driven decisions and reach our customers\n    effectively.\u201C"
}, {
  company: "arduino",
  logoName: "arduino",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ArduinoMonoLogo */.Yt2, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CA big benefit of Segment is being able to activate our first-party data all in one platform. Our previous\n    tool required more manual effort, and therefore limited our marketing communication options\u201C"
}, {
  company: "fender",
  logoName: "Fender",
  text: "To increase adoption and retention rates, Fender also uses tools from Twilio Segment to optimize the customer\n    sales funnel by streamlining the onboarding process.",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FenderMonoLogo */.bf1, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  name: "",
  position: "",
  extendedRate: "29%",
  extendedText: "reduction in customer churn rate for paid app",
  extendedLink: "/customers/fender"
}, {
  company: "trademe",
  logoName: "TradeMe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradeMeMonoLogo */.KH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe marketing team has been making very good use of CustomerAI Predictions, and we are keen on continuing to use it to drive campaigns across digital channels.\u201D"
}, {
  company: "camping-world",
  logoName: "CampingWorld",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CampingWorldMonoLogo */.H1r, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Engage allows Camping World to track events like \u2018RV model viewed\u2019 and \u2018RV added to favorites list\u2019 to create profiles, then utilize this information to craft specific omni-channel messages.\u201D"
}, {
  company: "adevinta",
  logoName: "Adevinta",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdevintaMonoLogo */.fGv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "With Segment at its core, Adevinta will enable cross-organizational collaboration through standardized data leading to relevant, personalized customer touch points across all its channels."
}, {
  company: "vervoe",
  logoName: "Vervoe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VervoeMonoLogo */.VhY, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe rely on Segment pretty heavily to feed all of the platforms to understand where the breakdowns are within the customer journey.\u201D"
}, {
  company: "tillster",
  logoName: "Tillster",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TillsterMonoLogo */.Tys, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Segment, we are able to use more personalization and intelligent targeting\u201C"
}, {
  company: "smartcar",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBuilding a user-friendly API isn\u2019t always easy\u2014especially if you want to appeal to your users and their users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure and evaluate the things they feel are most important.\u201D"
  }),
  name: "Sanketh Katta",
  position: "CTO and co-founder, Smartcar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SmartcarMonoLogo */.DXF, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SmartcarLogo */.GQ7, {}),
  logoName: "Smartcar",
  extendedRate: "22%",
  extendedText: "improvement in developer application conversions",
  extendedLink: "/customers/smartcar/"
}, {
  company: "lens-online",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CWhile our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers, integrating every customer interaction and preference with a customer data platform.\u201D"
  }),
  name: "Pascal",
  position: "CMO & CDO, LensOnline",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LensOnlineMonoLogo */.FRf, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LensOnlineLogo */.vmS, {}),
  logoName: "Fender",
  extendedRate: "15%",
  extendedText: "reduction in marketing spend",
  extendedLink: "/customers/lens-online/"
}, {
  company: "veronica-beard",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBased on our research, we know that omnichannel customers are our most valuable customers. Because of this, we build Twilio Engage Audiences of our omnichannel customers and top customers in lifetime revenue, to use as the basis for lookalike audiences in Facebook Ads.\u201D"
  }),
  name: "Maxime Lagresle",
  position: "Ecommerce Analytics Manager",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VeronicaBeardMonoLogo */.i_T, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "VeronicaBeard",
  extendedRate: "20% ",
  extendedText: "Reduction in customer acquisition costs (CAC) from Facebook Ads",
  extendedLink: "/customers/veronica-beard/"
}];
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/Testimonial.tsx







var TestimonialTemplate = function TestimonialTemplate(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "base" : _ref$variant,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? variant === "extended" ? "460px" : "auto" : _ref$height,
      overrides = _ref.overrides,
      company = _ref.company,
      color = _ref.color,
      logo = _ref.logo,
      text = _ref.text,
      avatar = _ref.avatar,
      name = _ref.name,
      position = _ref.position,
      extendedRate = _ref.extendedRate,
      extendedRateSymbol = _ref.extendedRateSymbol,
      extendedText = _ref.extendedText,
      extendedLink = _ref.extendedLink;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var companyData = data.find(function (item) {
    return item.company === company;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* default */.ZP, {
    variant: variant,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
      color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
      overrides: overrides,
      height: height,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
          children: (companyData === null || companyData === void 0 ? void 0 : companyData.logo) || logo
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
          children: text || (companyData === null || companyData === void 0 ? void 0 : companyData.text)
        })]
      }), (name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseAuthorSlot */.hC, {
        children: [(avatar || (companyData === null || companyData === void 0 ? void 0 : companyData.avatar)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorAvatar */.DV, {
          alt: "Portrait of" + name,
          src: avatar || String(companyData === null || companyData === void 0 ? void 0 : companyData.avatar)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
            children: name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
            children: position || (companyData === null || companyData === void 0 ? void 0 : companyData.position)
          })]
        })]
      })]
    }), variant === "extended" && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Extended */.jW, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedTextSlot */.VJ, {
        children: [(extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedHeader */.S2, {
          color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
          children: [extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate), (extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedHeaderSup */.Jk, {
            children: extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedText */.wN, {
          children: extendedText || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedText)
        })]
      }), (extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButtonSlot */.Wi, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedStoryLink */.c9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButton */.Di, {
            colored: Boolean(color),
            href: (0,getAbsoluteUrl/* default */.Z)(extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink) || "", pageConfig),
            text: "Read their story"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Testimonial_Testimonial = (TestimonialTemplate);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/index.ts


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 28470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/twilio",
      function () {
        return __webpack_require__(29655);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 45641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeoutFn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    var isReady = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return ready.current; }, []);
    var set = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}


/***/ }),

/***/ 11920:
/***/ (function(module) {

module.exports = "/_next/static/images/CreateOneCustomerConversation@2x-b0e19752327cad868463e4907cf8b060.png";

/***/ }),

/***/ 84041:
/***/ (function(module) {

module.exports = "/_next/static/images/DelightYourCustomers@2x-d19daf45bac9907106534cbe6023076c.png";

/***/ }),

/***/ 71540:
/***/ (function(module) {

module.exports = "/_next/static/images/LovedBy10MillionDevelopers@2x-aced453c09ef3fb7b5d1a974674e7a28.png";

/***/ }),

/***/ 49585:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeEveryInteractionMeaningful@2x-4ec4ab34553c0ea8008784d877a764d1.png";

/***/ }),

/***/ 82446:
/***/ (function(module) {

module.exports = "/_next/static/images/State-5ab1f4e1562d886144eae94993277168.png";

/***/ }),

/***/ 3460:
/***/ (function(module) {

module.exports = "/_next/static/images/Twilio-485c9e2334338d74a6744b4a0d4dfae7.png";

/***/ }),

/***/ 93453:
/***/ (function(module) {

module.exports = "/_next/static/images/TwilioSegment@2x-e18b7c8dd6b6e3544d33743ebe0c1336.png";

/***/ }),

/***/ 729:
/***/ (function(module) {

module.exports = "/_next/static/images/CreateOneCustomerConversation-e9c4d985b36021e6bad7750c0006e5a7.webp";

/***/ }),

/***/ 36460:
/***/ (function(module) {

module.exports = "/_next/static/images/CreateOneCustomerConversation@2x-4aba29e24db8d6a83985698116b6f846.webp";

/***/ }),

/***/ 3520:
/***/ (function(module) {

module.exports = "/_next/static/images/DelightYourCustomers-864207686f9b3bb99d7f84f25bb76609.webp";

/***/ }),

/***/ 58452:
/***/ (function(module) {

module.exports = "/_next/static/images/DelightYourCustomers@2x-2b9ca708c077938542fde637bdecd01d.webp";

/***/ }),

/***/ 60697:
/***/ (function(module) {

module.exports = "/_next/static/images/LovedBy10MillionDevelopers-53332698b1d5aa28a021bbb2ef782b36.webp";

/***/ }),

/***/ 35197:
/***/ (function(module) {

module.exports = "/_next/static/images/LovedBy10MillionDevelopers@2x-621761a64ecb9b1ff0b9a8fda6e9ad4d.webp";

/***/ }),

/***/ 61583:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeEveryInteractionMeaningful-b228de45eebe1d21c0ba2c8701450218.webp";

/***/ }),

/***/ 95198:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeEveryInteractionMeaningful@2x-be6335a1dc66ad245ac3c13267d9ec6a.webp";

/***/ }),

/***/ 64183:
/***/ (function(module) {

module.exports = "/_next/static/images/TwilioSegment@2x-77fb8d9983417940fb0b3f92e5047716.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,1382,4136,8392,2073,7096,2429,7303,8187,3922,8536,4881,5062,814,9774,2888,179], function() { return __webpack_exec__(28470); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);